import { type Meta } from '../types/docs';
import { AGENT_ONBOARDING_TIME_SINK_IDS } from './agentOnboardingAnalytics';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

const TIME_SINK_ENUM_VALUES = [...AGENT_ONBOARDING_TIME_SINK_IDS];

const META: Meta = {
  description: 'The hero outcome is committed when Next sends the answers',
  name: 'agent_onboarding_outcome_selected',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The winning time sink whose demo will play',
      name: 'outcome',
      required: true,
      type: 'enum',
      values: TIME_SINK_ENUM_VALUES,
    },
    {
      description: 'The scripted preview that outcome resolves to',
      name: 'resolved_preview_id',
      required: true,
      type: 'enum',
      values: TIME_SINK_ENUM_VALUES,
    },
  ],
};

export default META;
